
import React from "react";
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

import logo from "../../../../assets/logo.png";
import user from "../../../../assets/icons/user.png";
import phone from "../../../../assets/icons/phone.png";
import mail from "../../../../assets/icons/mail.png";


const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontFamily: "Helvetica",
        fontSize: 12,
        color: "#2D2D38"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 20,
        paddingBottom: 10,
        borderBottomWidth: 2,
        borderBottomColor: "#B91D1C"
    },
    logo: {
        width: 60,
        height: 60,
        marginRight: 15
    },
    headerTitle: {
        fontSize: 20,
        fontFamily: "Helvetica-Bold",
        color: "#B91D1C"
    },

    sectionTitle: {
        fontSize: 16,
        fontFamily: "Helvetica-Bold",
        marginTop: 20,
        marginBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: "#B91D1C",
        paddingBottom: 3
    },

    infoRow: {
        flexDirection: "row",
        marginBottom: 8,
        alignItems: "center"
    },
    icon: {
        width: 12,
        height: 12,
        marginRight: 6
    },
    infoLabel: {
        fontFamily: "Helvetica-Bold",
        marginRight: 4
    },

  
    summaryBox: {
        padding: 10,
        backgroundColor: "#F5F5F5",
        borderRadius: 6,
        borderWidth: 1,
        borderColor: "#DDD",
        marginBottom: 20
    },
    barBackground: {
        width: "100%",
        height: 8,
        backgroundColor: "#E5E7EB",
        borderRadius: 4,
        marginTop: 2
    },
    barFill: {
        height: 8,
        borderRadius: 4
    },


    questionCard: {
        borderWidth: 1,
        borderColor: "#DDD",
        borderRadius: 6,
        padding: 10,
        marginBottom: 12,
        backgroundColor: "#F9FAFB"
    },

    questionHeader: {
        backgroundColor: "#EEE",
        padding: 6,
        borderRadius: 4,
        marginBottom: 8
    },
    questionText: {
        fontFamily: "Helvetica-Bold",
        fontSize: 12
    },

    questionBodyRow: {
        flexDirection: "row",
        borderTopWidth: 1,
        borderTopColor: "#DDD",
        paddingTop: 6,
        marginTop: 4
    },

    colLeft: { width: "30%" },
    colRight: { width: "70%" },
    labelBold: { fontFamily: "Helvetica-Bold" },

  
    answerContainer: {
        marginTop: 6,
        paddingTop: 6,
        borderTopWidth: 1,
        borderTopColor: "#DDD",
        flexDirection: "column"
    },

    answerWrapper: {
        maxHeight: 120,        
        overflow: "hidden",    
        marginTop: 5
    },

   
    answerText: {
        marginTop: 4,
        lineHeight: 1.4,
        textAlign: "justify",
        wordBreak: "break-word", 
        whiteSpace: "pre-wrap",  
        maxWidth: "100%"         
    }
});


const PdfReporteEvaluacion = ({ persona, formulario, respuestas }) => {

    const likert = respuestas.filter(r => r.tipoPregunta?.toLowerCase() === "likert");

    const siNo = respuestas.filter(r =>
        ["si/no", "sino", "sí/no"].includes(r.tipoPregunta?.toLowerCase())
    );

    const promedioGlobal = (() => {
        const valores = likert.map(r => parseFloat(r.respuesta));
        if (!valores.length) return 0;
        return (valores.reduce((a, b) => a + b, 0) / valores.length).toFixed(2);
    })();

    const totalSi = siNo.filter(r =>
        ["si", "sí"].includes(r.respuesta?.toLowerCase())
    ).length;

    const totalNo = siNo.filter(r => r.respuesta?.toLowerCase() === "no").length;

    const total = totalSi + totalNo;
    const porcSi = total ? (totalSi / total) * 100 : 0;
    const porcNo = total ? (totalNo / total) * 100 : 0;

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                
                <View style={styles.headerContainer}>
                    <Image src={logo} style={styles.logo} />
                    <Text style={styles.headerTitle}>Reporte de Evaluación</Text>
                </View>

                
                <Text style={styles.sectionTitle}>Información General</Text>

                <View style={styles.infoRow}>
                    <Image src={user} style={styles.icon} />
                    <Text style={styles.infoLabel}>Evaluado:</Text>
                    <Text>{persona?.nombre}</Text>
                </View>

                <View style={styles.infoRow}>
                    <Image src={mail} style={styles.icon} />
                    <Text style={styles.infoLabel}>Formulario:</Text>
                    <Text>{formulario?.nombre}</Text>
                </View>

                
                <Text style={styles.sectionTitle}>Resumen General</Text>

                <View style={styles.summaryBox}>
                    <Text style={{ marginBottom: 5 }}>
                        <Text style={styles.infoLabel}>Promedio Global Likert:</Text> {promedioGlobal}
                    </Text>

                    <Text>
                        <Text style={styles.infoLabel}>Respuestas Sí / No:</Text> {totalSi} Sí — {totalNo} No
                    </Text>

                    <Text style={{ marginTop: 10, fontFamily: "Helvetica-Bold" }}>
                        Distribución Sí / No
                    </Text>

                    
                    <Text>Sí ({porcSi.toFixed(0)}%)</Text>
                    <View style={styles.barBackground}>
                        <View style={[styles.barFill, { width: `${porcSi}%`, backgroundColor: "#10B981" }]} />
                    </View>

                    
                    <Text style={{ marginTop: 10 }}>No ({porcNo.toFixed(0)}%)</Text>
                    <View style={styles.barBackground}>
                        <View style={[styles.barFill, { width: `${porcNo}%`, backgroundColor: "#EF4444" }]} />
                    </View>
                </View>

                
                <Text style={styles.sectionTitle}>Preguntas y Respuestas</Text>

                {respuestas.map((r, index) => (
                    <View key={index} style={styles.questionCard}>

                        
                        <View style={styles.questionHeader}>
                            <Text style={styles.questionText}>{r.pregunta}</Text>
                        </View>

                        
                        <View style={styles.questionBodyRow}>
                            <View style={styles.colLeft}>
                                <Text style={styles.labelBold}>Tipo:</Text>
                            </View>
                            <View style={styles.colRight}>
                                <Text>{r.tipoPregunta}</Text>
                            </View>
                        </View>

                        
                        <View style={styles.answerContainer}>
                            <Text style={styles.labelBold}>Respuesta:</Text>

                            <View style={styles.answerWrapper}>
                                <Text style={styles.answerText}>{r.respuesta || "—"}</Text>
                            </View>
                        </View>

                    </View>
                ))}

            </Page>
        </Document>
    );
};

export default PdfReporteEvaluacion;
